import styled from 'styled-components';
import {IoIosRadioButtonOn} from 'react-icons/io';

export const Ioradio = styled(IoIosRadioButtonOn)`
  color: #FF7400;
`
